export {};

declare global {
    interface Array<T> {
        /** @deprecated list = list.filter(a => a != search) に置き換えること */
        remove(searchElement: T): boolean;
    }
}

Array.prototype.remove = function <T>(v: T): boolean {
    if (!this.includes(v)) return false;
    this.splice(this.indexOf(v), 1);
    return true;
};
